import React, { Component } from "react"

class LoginLink extends Component {
  constructor(props) {
    super(props)
    this.popup = {}
  }

  handleLoginClick = (e) => {
    e.preventDefault()
    if (this.props.trackingHandler && typeof this.props.trackingHandler === "function") {
      this.props.trackingHandler()
    }
    this.cphPopup(this.props.loginurl, "xtf", "470", "675")
  }

  cphPopup = (url, title, w, h) => {
    // Fixes dual-screen position
    var dualScreenLeft = window.screenLeft !== undefined ? window.screenLeft : window.screen.left
    var dualScreenTop = window.screenTop !== undefined ? window.screenTop : window.screen.top

    var width = window.innerWidth
      ? window.innerWidth
      : document.documentElement.clientWidth
        ? document.documentElement.clientWidth
        : window.screen.width

    var height = window.innerHeight
      ? window.innerHeight
      : document.documentElement.clientHeight
        ? document.documentElement.clientHeight
        : window.screen.height

    var left = width / 2 - w / 2 + dualScreenLeft

    var top = height / 2 - h / 2 + dualScreenTop

    this.popup.newWindow = window.open(
      url,
      title,
      "titlebar=no,toolbar=no,location=no,status=no,menubar=no,scrollbars=yes,resizable=no," +
        "width=" +
        w +
        ", height=" +
        h +
        ", top=" +
        top +
        ", left=" +
        left,
    )

    this.popup.dialogTimer = setInterval(this.checkIfWindowClosed, 100)

    // Puts focus on the CPH IDP upon initiating
    if (window.focus) {
      this.popup.newWindow.focus()
    }
  }

  checkIfWindowClosed = () => {
    if (this.popup.newWindow.closed) {
      console.debug("Child window closed")
      clearInterval(this.popup.dialogTimer)
      window.location.reload()
    }
  }

  render() {
    return (
      <button
        aria-label={this.props.loginLinkAria || ""}
        tabIndex={this.props.isInactive ? "-1" : ""}
        className={this.props.linkClassName}
        onClick={this.handleLoginClick}
      >
        {!this.props.isShop ? (
          <p className={this.props.spanClassName}>{this.props.linkText}</p>
        ) : (
          <span className={this.props.spanClassName}>{this.props.linkText}</span>
        )}
      </button>
    )
  }
}

export default LoginLink
